/**
 * @export
 * @class Share
 * 공유하기
 */

function copyUrl() {
  const sUrl = `${TMON.htLocal.htURL.www_m_deals}${TMON.htStaticData.sDealNo}`;
  let bSuccess = false;
  $('#clip_target').attr('readonly', true);
  $('#clip_target').val(sUrl);
  $('#clip_target').select();
  $('#clip_target')
    .get(0)
    .setSelectionRange(0, 9999); // 아이폰의 경우 복사할 영역을 지정해 주어야함
  try {
    const successful = document.execCommand('copy');
    if (successful) {
      bSuccess = true;
    } else {
      bSuccess = false;
    }
  } catch (err) {
    bSuccess = false;
  }

  if (bSuccess) {
    alert('URL 이 복사되었습니다. 공유를 원하시는 곳에 붙여넣기하세요');
  } else {
    alert(
      'URL 복사를 지원하지 않는 브라우저입니다. 상단 주소창의 URL 을 복사해 공유해 주세요!'
    );
  }
}

export const getShareData = () => {
  const ogPriceEl = document.querySelector('meta[property="og:price"]');
  const ogUrlEl = document.querySelector('meta[property="og:url"]');
  const ogDescriptionEl = document.querySelector('meta[property="og:description"]');
  const ogImageEl = document.querySelector('meta[property="og:image"]');
  const ogTitleEl = document.querySelector('meta[property="og:title"]');

  const { scene, order_no: orderNo } = TMON.util.getHashJSON();
  let sUrl = '';
  if (scene === 'scene-optiondetail') {
    sUrl = `${TMON.htLocal.htURL.www_m_deals}${TMON.htStaticData.sDealNo}#scene=scene-optiondetail&order_no=${orderNo}`;
  } else if (ogUrlEl) {
    sUrl = ogUrlEl.getAttribute('content');
  }

  return  {
    sContent: ogPriceEl ? ogPriceEl.getAttribute('content') : ogDescriptionEl.getAttribute('content'),
    sHashTags: '티몬',
    /**
     * SnsShare 객체는 앱에서 한번만 만들어야 하고 2개 이상 만들경우 타이밍 이슈가 생긴다
     * multiple selector를 사용하여 모든 쉐어 버튼들을 선택함(이미 html에 render 되있어야함). */
    sSelector:
      '.share-lst .share, .pop_fixed_share, .give_gift_list .give_gift_item .give_gift_itembutton, .share_deal_sns_list .share_deal_sns_btn',
    sDealNo: TMON.oApp.htStorage.htStaticData.sDealNo,
    sImage: ogImageEl ? ogImageEl.getAttribute('content') : '',
    sTitle: ogTitleEl ? ogTitleEl.getAttribute('content') : '',
    sUrl,
    cbOnCompleted: arg => {
      if (
        (TMON.oApp.sPlatform === 'PW' || TMON.oApp.sPlatform === 'MW') &&
        arg[0] === 'urlcopy'
      ) {
        copyUrl();
      }
    },
  };

} 
export default class Share {
  constructor() {
    const htSnsShare = getShareData();

    // 공유특가 딜일 경우 파라미터 추가
    if (TMON.bLogin && TMON.htStaticData.isShareDeal) {
      htSnsShare.memberNo = TMON.memberNo;
      htSnsShare.oneTimeKey =
        TMON.htStaticData.shareDealInfo.shareDealOneTimeKey;
      htSnsShare.appLaunchPath = 'share_sp_deal';
    }

    // 공유 특가딜 진입시 트레킹코드
    if (TMON.htStaticData.isShareDeal) {
      const tlAlrea = TMON.oApp.sPlatform === 'PW' ? 'SDPFC' : 'SDMFC';
      const target = $('.deal_share').get(0);
      TMON.sendLog(null, [
        target,
        null,
        {
          'tl:area': tlAlrea,
        },
      ]);
    }

    /* global SnsShare */
    /* eslint-disable no-new */
    new SnsShare(htSnsShare);
  }
}
